import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {ProcessRunService } from '../../process-runner-select/shared/process-run.service';
import { UIService } from '../../shared/ui.service';
import { AncClientSettings, AncSettingsService, UpdateAncClientSettingsFron } from '../anc-settings.service';

@Component({
  selector: 'app-clients-table',
  templateUrl: './clients-table.component.html',
  styleUrls: ['./clients-table.component.css']
})
export class ClientsTableComponent implements OnInit {
  fetch_clients() {
    this.ancSets.getAncClinentSettings().subscribe(
      (res: AncClientSettings[]) => {
        this.dataSource.data = res;
        this.dataSource.data.map((e, i) => {
          e.IsSelected = false;
          e.oldmode = e.mode;
          e.oldOptype = e.outputType;
          e.oldPublishEnabled = e.googlePublishAsEnabled == true ? "1" : "0";
          e.googlePublishAsEnabled = e.googlePublishAsEnabled==true?"1":"0"
          if (i % 2 == 0) {
            //e.isJobInProgress = true;
          }
        })
        this.dsiableAll = false;
      },
      (err) => {
        this.dsiableAll = false;

      }
    );
  }

  disableSave(row: AncClientSettings) {
    if ((row.oldmode != row.mode) || (row.oldOptype != row.outputType) || (row.googlePublishAsEnabled != row.oldPublishEnabled)) {
      return false;
    } else {
      return true;
    }
  }

  mainChecked: boolean = false;
  selectAll(ex) {


    const skip = this.paginator.pageSize * this.paginator.pageIndex;
    let data = this.dataSource.filteredData;
    if (data.length == 0) {
      data = this.dataSource.data;
    }
    const pagedData = data.filter((u, i) => i >= skip)
      .filter((u, i) => i < this.paginator.pageSize);
    let s = [];
    pagedData.forEach((e) => {
      s.push(e.clientID);
    })
    this.dataSource.data.map((e) => {
      if (s.includes(e.clientID) && !e.isJobInProgress) {
        e.IsSelected = ex.checked;
      }
    })
  }

  handlePage() {
    let allTrue = true;
    const skip = this.paginator.pageSize * this.paginator.pageIndex;
    let data = this.dataSource.filteredData;
    if (data.length == 0) {
      data = this.dataSource.data;
    }
    const pagedData = data.filter((u, i) => i >= skip)
      .filter((u, i) => i < this.paginator.pageSize);
    pagedData.forEach((e) => {
      if (e.IsSelected == false) {
        allTrue = false;
      }
    })
    if (allTrue) {
      this.mainChecked = true;
    } else {
      this.mainChecked = false;
    }
  }

  displayedColumns: string[] = ['chk', 'id', 'name', 'outputType', 'mode','enabled', 'save'];
  dataSource: MatTableDataSource<AncClientSettings>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private processSer: ProcessRunService, private ancSets: AncSettingsService, private uis: UIService) {

    this.dataSource = new MatTableDataSource([]);
  }
  checkedRows: AncClientSettings[] = [];
  //chk(e, row: clients) {
  //  let find = this.checkedRows.filter((e) => {
  //    e.clientID == row.clientID
  //  }).length > 0;
  //  if (!find) {
  //    this.checkedRows.push(row);
  //  }
  //}
  needDisable() {
    return this.dataSource.data.filter((e) => {
      return e.IsSelected == true;
    }).length

  }
  changeOptype(e, c_id) {

    this.dataSource.data.map(es => {
      if (es.clientID == c_id) {
        if (e.value === "GoogleDrive") {
          es.mode = false
        }
      }
    });


  }
  changeAllopt(e) {
    if (this.allOpt == "GoogleDrive") {
      this.allMode = false
        ;
    }
  }

  async UpdateSettings(row: AncClientSettings) {
    this.dsiableAll = true;
    try {
      let clf: UpdateAncClientSettingsFron = {
        clientID: row.clientID,
        name: row.name,
        mode: row.mode,
        isJobInProgress: row.isJobInProgress,
        outputType: row.outputType,
        GooglePublishAsEnabled: row.googlePublishAsEnabled=="1"
      }
      let res:any = await this.ancSets.updateAncClientSettings(clf)
      if (res?.message) {
        this.uis.showSnackbar(row.name + " Client settings updated successfully", null, 3000, true)
        this.fetch_clients();
      } else {
        this.uis.showSnackbar(row.name + " Client settings Not Updated", null, 3000, false)
        this.dsiableAll = false;

      }
    }
    catch (error) {
      this.dsiableAll = false;

      this.uis.showSnackbar(row.name + " Client settings Not Updated", null, 3000, false)
    }
  }
  allOpt: string = "Both";
  allMode: boolean = false;
  dsiableAll: boolean = false;

  chkRefresh() {
    this.fetch_clients();
  }
  async UpdateAlllsettings() {
    this.dsiableAll = true;
    let count = 0;
    let selectedClients: AncClientSettings[] = this.dataSource.data.filter((e) => {
      return e.IsSelected == true;
    })
    selectedClients.forEach(async (e) => {
      try {
        let clf: UpdateAncClientSettingsFron = {
          clientID: e.clientID,
          name: e.name,
          mode: this.allMode,
          isJobInProgress: e.isJobInProgress,
          outputType: this.allOpt,
          GooglePublishAsEnabled: e.googlePublishAsEnabled=="1"
        }
        let res: any = await this.ancSets.updateAncClientSettings(clf)
        count=count+1;
      } catch (error) {
        count = count + 1;
      }
      if (selectedClients.length == count) {
        this.chkRefresh();
        this.uis.showSnackbar("Selected Clients settings updated successfully", null, 3000, true)
      }
    })
    this.mainChecked = false;
  }


  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.fetch_clients();
  }
  optOptions: string[] = ["GoogleDrive", "Both", "GoogleAPI"];
  modeOptions: { name: string, val: boolean }[] = [{ name: "Regular", val: false }, { name: "Verbose", val: true }];

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
